export const REQUEST_PROPOSAL_TOGGLE_DEAL_TYPE = 'REQUEST_PROPOSAL/TOGGLE_DEAL_TYPE';
export const REQUEST_PROPOSAL_TOGGLE_INCENTIVE = 'REQUEST_PROPOSAL/TOGGLE_INCENTIVE';
export const REQUEST_PROPOSAL_UPDATE_NOTES = 'REQUEST_PROPOSAL/UPDATE_NOTES';
export const REQUEST_PROPOSAL_RESET = 'REQUEST_PROPOSAL/RESET';
export const OPEN_REQUEST_CHANGE_MODAL = 'OPEN_REQUEST_CHANGE_MODAL';

export const UPDATE_DEAL_REQUEST = 'UPDATE_DEAL_REQUEST';
export const UPDATE_DEAL_SUCCESS = 'UPDATE_DEAL_SUCCESS';
export const UPDATE_DEAL_FAILURE = 'UPDATE_DEAL_FAILURE';

// Deal summary PDF lifecycle (owned by this activity)
export const FETCH_DEAL_SUMMARY_PDF_REQUEST = 'FETCH_DEAL_SUMMARY_PDF_REQUEST';
export const FETCH_DEAL_SUMMARY_PDF_SUCCESS = 'FETCH_DEAL_SUMMARY_PDF_SUCCESS';
export const FETCH_DEAL_SUMMARY_PDF_FAILURE = 'FETCH_DEAL_SUMMARY_PDF_FAILURE';
export const GET_DEAL_SUMMARY_PDF = 'GET_DEAL_SUMMARY_PDF';

export const SHOW_CONFETTI = 'SHOW_CONFETTI';
export const ACCEPT_DEAL_SUMMARY_REQUEST = 'ACCEPT_DEAL_SUMMARY_REQUEST';

export const REQUEST_PROPOSAL_SEND_REQUEST_CLICKED = 'REQUEST_PROPOSAL_SEND_REQUEST_CLICKED';
export const REQUEST_PROPOSAL_ACCEPT_DEAL_CLICKED = 'REQUEST_PROPOSAL_ACCEPT_DEAL_CLICKED';
export const SEND_DEAL_SUMMARY_REQUEST_LOADER = 'SEND_DEAL_SUMMARY_REQUEST_LOADER';
export const DEAL_PDF_LOADED_SUCCESS = 'DEAL_PDF_LOADED_SUCCESS';
export const FETCH_DEAL_SUCCESS = 'FETCH_DEAL_SUCCESS';
